import styled from "@emotion/styled"
import { section } from "../../styles"

export default styled.section`
  ${section}
`
